import { mockCommissionByFactory } from "@/mocks/reseller";

const CommissionTable = () => (
  <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
    <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
      <h2 className="font-bold text-gray-900 text-sm">Commission by Factory</h2>
      <span className="text-xs text-gray-400">Each factory sets their own rate</span>
    </div>
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="bg-gray-50 text-xs text-gray-500 uppercase tracking-wide">
            <th className="text-left px-5 py-3 font-semibold">Factory</th>
            <th className="text-left px-5 py-3 font-semibold">Country</th>
            <th className="text-center px-5 py-3 font-semibold">Commission %</th>
            <th className="text-center px-5 py-3 font-semibold">My Sales</th>
            <th className="text-right px-5 py-3 font-semibold">Earned</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-50">
          {mockCommissionByFactory.map((f) => (
            <tr key={f.id} className="hover:bg-gray-50 transition-colors">
              <td className="px-5 py-4">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-lg overflow-hidden flex-shrink-0 bg-gray-100">
                    <img src={f.logo} alt={f.name} className="w-full h-full object-cover object-top" />
                  </div>
                  <div>
                    <div className="font-semibold text-gray-900 text-xs">{f.name}</div>
                    <div className="text-[10px] text-gray-400">{f.category}</div>
                  </div>
                </div>
              </td>
              <td className="px-5 py-4">
                <span className={`text-xs font-semibold px-2 py-1 rounded-full ${
                  f.country === "USA"
                    ? "bg-blue-50 text-blue-700"
                    : "bg-red-50 text-red-700"
                }`}>
                  {f.country === "USA" ? "🇺🇸" : "🇨🇦"} {f.country}
                </span>
              </td>
              <td className="px-5 py-4 text-center">
                <span className="inline-flex items-center gap-1 bg-[#D4AF37]/10 text-[#B8860B] font-bold text-sm px-3 py-1 rounded-full">
                  {f.commission}%
                </span>
              </td>
              <td className="px-5 py-4 text-center">
                <span className="font-semibold text-gray-700">{f.sales}</span>
              </td>
              <td className="px-5 py-4 text-right">
                <span className="font-bold text-[#C41E3A]">${f.earned.toLocaleString()}</span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default CommissionTable;
